var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", [
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            id: "view-button",
                            size: "sm",
                            variant: "warning"
                          },
                          on: { click: _vm.toggleView }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon:
                                _vm.viewMode === "table" ? "th-large" : "list"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: "view-button",
                            triggers: "hover",
                            variant: "warning",
                            noninteractive: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.viewMode === "table" ? "Канбан" : "Таблица"
                              ) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle.sidebar-fields",
                              modifiers: { "sidebar-fields": true }
                            }
                          ],
                          staticClass: "mr-2",
                          attrs: {
                            id: "table-settings",
                            size: "sm",
                            variant: "warning"
                          },
                          on: { click: _vm.onPopoverClose }
                        },
                        [_c("font-awesome-icon", { attrs: { icon: "cog" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: "table-settings",
                            triggers: "hover",
                            variant: "warning",
                            noninteractive: ""
                          }
                        },
                        [_vm._v("\n            Колонки\n          ")]
                      ),
                      _vm._v(" "),
                      _vm.canEditRecruitTasks()
                        ? _c(
                            "b-btn",
                            {
                              attrs: {
                                size: "sm",
                                variant: "success",
                                disabled: _vm.isBusy
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showModal(null, false)
                                }
                              }
                            },
                            [
                              _vm.isBusy
                                ? _c("b-spinner", { attrs: { small: "" } })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "plus" }
                              }),
                              _vm._v("\n            Новая\n          ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-navbar",
        { attrs: { variant: "light" } },
        [
          _c(
            "b-navbar-nav",
            [
              !_vm.isIntegrated
                ? _c(
                    "filters-drawer",
                    {
                      attrs: {
                        "hide-search": true,
                        "is-busy": _vm.isBusy,
                        "filter-tags": _vm.activeFilterTags
                      },
                      on: {
                        "remove-tag": _vm.removeFilterTag,
                        submit: _vm.onSearch,
                        clear: _vm.onClearFilters
                      }
                    },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Вакансии")
                          ]),
                          _vm._v(" "),
                          _c("vacancy-multi-select", {
                            ref: "vacancy_multi_select",
                            attrs: { id: "vacancy-multi-select" },
                            on: { onSelect: _vm.onSelectVacancy }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Дата открытия")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "align-items-center" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-start-opened-date",
                                      size: "sm",
                                      type: "date"
                                    },
                                    model: {
                                      value: _vm.filters.start_opened_date,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "start_opened_date",
                                          $$v
                                        )
                                      },
                                      expression: "filters.start_opened_date"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "px-2",
                                  attrs: { cols: "auto" }
                                },
                                [_c("span", [_vm._v("—")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-end-opened-date",
                                      size: "sm",
                                      type: "date"
                                    },
                                    model: {
                                      value: _vm.filters.end_opened_date,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "end_opened_date",
                                          $$v
                                        )
                                      },
                                      expression: "filters.end_opened_date"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Дата закрытия")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "align-items-center" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-start-closed-date",
                                      size: "sm",
                                      type: "date"
                                    },
                                    model: {
                                      value: _vm.filters.start_closed_date,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "start_closed_date",
                                          $$v
                                        )
                                      },
                                      expression: "filters.start_closed_date"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "px-2",
                                  attrs: { cols: "auto" }
                                },
                                [_c("span", [_vm._v("—")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-end-closed-date",
                                      size: "sm",
                                      type: "date"
                                    },
                                    model: {
                                      value: _vm.filters.end_closed_date,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "end_closed_date",
                                          $$v
                                        )
                                      },
                                      expression: "filters.end_closed_date"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Объекты")
                          ]),
                          _vm._v(" "),
                          _c("location-multi-select", {
                            ref: "location_multi_select",
                            attrs: { id: "location-multi-select" },
                            on: { onSelect: _vm.onSelectLocation }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Участники")
                          ]),
                          _vm._v(" "),
                          _c("user-multi-select", {
                            ref: "user_multi_select",
                            attrs: {
                              id: "user-multi-select",
                              title: "Участники"
                            },
                            on: { onSelect: _vm.onSelectUser }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Ответственные")
                          ]),
                          _vm._v(" "),
                          _c("user-multi-select", {
                            ref: "user_multi_select_assigned",
                            attrs: {
                              id: "user-multi-select-assigned",
                              title: "Ответственные"
                            },
                            on: { onSelect: _vm.onSelectUserAssigned }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "b-row",
                            { staticClass: "align-items-center" },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "small text-muted" },
                                    [_vm._v("Статус")]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-select", {
                                    attrs: {
                                      id: "input-statuses",
                                      size: "sm",
                                      options: _vm.statusOptions
                                    },
                                    model: {
                                      value: _vm.filters.status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filters, "status", $$v)
                                      },
                                      expression: "filters.status"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "small text-muted" },
                                    [_vm._v("Срочно")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: {
                                        id: "input-urgency",
                                        size: "sm"
                                      },
                                      model: {
                                        value: _vm.filters.urgency,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filters, "urgency", $$v)
                                        },
                                        expression: "filters.urgency"
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: null } },
                                        [_vm._v("Все заявки")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: true } },
                                        [_vm._v("Да")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: false } },
                                        [_vm._v("Нет")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Теги")
                          ]),
                          _vm._v(" "),
                          _c("recruit-tag-multi-select", {
                            ref: "tag_multi_select",
                            attrs: { id: "tag-multi-select" },
                            on: { onSelect: _vm.onSelectTag }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.viewMode === "table"
        ? _c("b-table", {
            ref: "recruit_tasks",
            staticClass: "mb-0 text-small",
            attrs: {
              id: "recruit-tasks",
              "select-mode": "multi",
              "head-variant": "light",
              "tbody-tr-class": _vm.tbodyRowClass,
              "sticky-header": "",
              striped: "",
              small: "",
              responsive: "",
              "show-empty": "",
              "empty-text": _vm.$t("message.common.emptyTable"),
              busy: _vm.isBusy,
              items: _vm.items,
              fields: _vm.renderedFields,
              "no-provider-filtering": "",
              "no-provider-paging": "",
              "no-provider-sorting": "",
              "no-local-sorting": ""
            },
            on: {
              "update:busy": function($event) {
                _vm.isBusy = $event
              },
              "sort-changed": _vm.sortChanged,
              "row-clicked": _vm.rowClicked,
              "row-dblclicked": _vm.onRowDblClicked
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "table-busy",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "text-center text-success my-2" },
                        [
                          _c("b-spinner", { staticClass: "align-middle" }),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Загрузка")])
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "head(selected)",
                  fn: function(row) {
                    return [
                      _c("b-form-checkbox", {
                        staticClass: "mx-1",
                        attrs: {
                          indeterminate: _vm.indeterminate,
                          disabled: _vm.allSelectDisabled,
                          size: "md"
                        },
                        on: { change: _vm.selectAllRows },
                        model: {
                          value: _vm.allSelected,
                          callback: function($$v) {
                            _vm.allSelected = $$v
                          },
                          expression: "allSelected"
                        }
                      })
                    ]
                  }
                },
                {
                  key: "cell(selected)",
                  fn: function(row) {
                    return [
                      row.item.selected
                        ? [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("✓")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Выбрана")
                            ])
                          ]
                        : [
                            _c("span", [_vm._v(" ")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Не выбрана")
                            ])
                          ]
                    ]
                  }
                },
                {
                  key: "cell(assigned)",
                  fn: function(row) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.getAssignedName(row.item.assigned)) +
                          "\n    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(status)",
                  fn: function(row) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.getStatusText(row.item.status)) +
                          "\n    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(opened_date)",
                  fn: function(row) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.formatTableDate(row.item.opened_date)) +
                          "\n    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(closed_date)",
                  fn: function(row) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.formatTableDate(row.item.closed_date)) +
                          "\n    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(urgency)",
                  fn: function(row) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(row.item.urgency ? "Да" : "Нет") +
                          "\n    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(tags)",
                  fn: function(row) {
                    return [
                      row.value
                        ? _c(
                            "div",
                            _vm._l(row.value, function(tag) {
                              return _c(
                                "b-badge",
                                {
                                  key: tag.id,
                                  staticClass: "mr-1 px-2 py-1",
                                  style: _vm.getBadgeStyle(tag.color),
                                  attrs: { pill: "" }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(tag.name) +
                                      "\n        "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(action)",
                  fn: function(row) {
                    return [
                      _c(
                        "b-dropdown",
                        {
                          attrs: { size: "sm", "no-caret": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button-content",
                                fn: function() {
                                  return [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "ellipsis-v" }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item-button",
                            {
                              attrs: { variant: "success" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showModal(row.item.id, true)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "eye" }
                              }),
                              _vm._v("\n          Смотреть\n        ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.canEditRecruitTasks()
                            ? _c(
                                "b-dropdown-item-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.showModal(row.item.id, false)
                                    }
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    attrs: { icon: "edit" }
                                  }),
                                  _vm._v("\n          Редактировать\n        ")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canEditRecruitJobPostings()
                            ? _c(
                                "b-dropdown-item-button",
                                {
                                  attrs: { variant: "info" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.handleJobPosting(row.item.id)
                                    }
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    attrs: { icon: "search-plus" }
                                  }),
                                  _vm._v(
                                    "\n          Создать объявление\n        "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canEditRecruitTasks()
                            ? _c(
                                "b-dropdown-item-button",
                                {
                                  attrs: { variant: "danger" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.onRemove(row)
                                    }
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    attrs: { icon: "trash" }
                                  }),
                                  _vm._v("\n          Удалить\n        ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              308960139
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.viewMode === "kanban"
        ? _c("kanban", {
            attrs: {
              items: _vm.items,
              columns: _vm.kanbanColumns,
              "group-name": "recruit-tasks"
            },
            on: { "status-updated": _vm.kanbanUpdateStatus },
            scopedSlots: _vm._u(
              [
                {
                  key: "card",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "b-card",
                        {
                          staticClass: "kb-card p-2 bg-white shadow-sm rounded",
                          class: item.urgency
                            ? "border-danger"
                            : "border-white",
                          attrs: { "no-body": "" },
                          on: {
                            dblclick: function($event) {
                              return _vm.onRowDblClicked(item)
                            }
                          }
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "mb-2" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mr-auto",
                                  attrs: { cols: "3" }
                                },
                                [
                                  _c(
                                    "strong",
                                    { staticClass: "text-primary" },
                                    [_vm._v("#" + _vm._s(item.id))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-end",
                                  attrs: { cols: "9" }
                                },
                                [
                                  _c(
                                    "b-badge",
                                    {
                                      staticClass: "border",
                                      attrs: { variant: "light" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatTableDate(item.opened_date)
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("—")]),
                                  _vm._v(" "),
                                  _c(
                                    "b-badge",
                                    {
                                      staticClass: "border",
                                      attrs: { variant: "light" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatTableDate(item.closed_date)
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mb-2 font-weight-bold" },
                            [
                              _c("b-col", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.location_vacancy_name) +
                                    "\n          "
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "small text-muted mb-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "green" },
                                    attrs: { icon: "map-marked-alt" }
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.location_name) +
                                      "\n          "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "small text-muted mb-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    attrs: { icon: "user" }
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.getAssignedName(item.assigned) ||
                                          "Не назначен"
                                      ) +
                                      "\n          "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr", { staticClass: "my-1" }),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex flex-wrap align-items-center",
                                  attrs: { cols: "10" }
                                },
                                [
                                  item.urgency
                                    ? _c(
                                        "b-badge",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { variant: "danger" }
                                        },
                                        [_vm._v("Срочно")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.tags
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "d-flex flex-wrap mt-1"
                                        },
                                        _vm._l(item.tags, function(tag) {
                                          return _c(
                                            "b-badge",
                                            {
                                              key: tag.id,
                                              staticClass:
                                                "mr-1 mb-1 px-2 py-1",
                                              staticStyle: {
                                                "font-size": "10px"
                                              },
                                              style: _vm.getBadgeStyle(
                                                tag.color
                                              ),
                                              attrs: { pill: "" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(tag.name) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        }),
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "d-flex justify-content-end",
                                  attrs: { cols: "2" }
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "p-0",
                                      attrs: { size: "sm", variant: "link" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onRowDblClicked(item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Открыть\n            "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              2150002981
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c("pagination-footer", {
        attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
        on: {
          "update:perPage": function($event) {
            _vm.perPage = $event
          },
          "update:per-page": function($event) {
            _vm.perPage = $event
          },
          "page-click": _vm.onPagination,
          "per-page-change": _vm.onPerPageChange
        },
        scopedSlots: _vm._u([
          {
            key: "footer-update",
            fn: function() {
              return [
                _vm.selected.length > 0
                  ? _c(
                      "b-row",
                      { attrs: { "align-h": "between", "align-v": "center" } },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "mr-auto text-small",
                            attrs: { cols: "auto" }
                          },
                          [
                            _vm._v("\n          Выбрано: "),
                            _c("b", [_vm._v(_vm._s(_vm.selected.length))])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { cols: "auto" } },
                          [
                            _c(
                              "b-button",
                              {
                                ref: "updateStatusButton",
                                attrs: {
                                  id: "updateStatusButton",
                                  size: "sm",
                                  variant: "info"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.popoverShow = !_vm.popoverShow
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "mr-1",
                                  attrs: { icon: "exchange-alt" }
                                }),
                                _vm._v(
                                  "\n            Изменить статус\n          "
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected.length > 0 ? _c("hr") : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _vm.selected.length > 0
        ? _c(
            "b-popover",
            {
              ref: "popover_recruitTasks",
              attrs: {
                target: "updateStatusButton",
                triggers: "click",
                show: _vm.popoverShow,
                placement: "auto",
                container: "my-container"
              },
              on: {
                "update:show": function($event) {
                  _vm.popoverShow = $event
                },
                shown: _vm.onShown,
                hidden: _vm.onHidden
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center w-100"
                          },
                          [
                            _c(
                              "small",
                              { staticClass: "font-weight-bold text-muted" },
                              [_vm._v("Назначить статус")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "close pb-1",
                                attrs: { "aria-label": "Close" },
                                on: { click: _vm.onPopoverClose }
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { "aria-hidden": "true" } },
                                  [_vm._v("×")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1590724775
              )
            },
            [
              _vm._v(" "),
              _c("b-form-select", {
                ref: "allTasksStatusSelect",
                staticClass: "mb-2",
                attrs: { size: "sm", options: _vm.statusOptions },
                model: {
                  value: _vm.selectedNewStatus,
                  callback: function($$v) {
                    _vm.selectedNewStatus = $$v
                  },
                  expression: "selectedNewStatus"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-1",
                      attrs: { size: "sm", variant: "secondary" },
                      on: { click: _vm.onPopoverClose }
                    },
                    [_vm._v("Закрыть")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: !_vm.selectedNewStatus || _vm.isBusy
                      },
                      on: { click: _vm.onPopoverOk }
                    },
                    [_vm._v("Назначить")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("dynamic-tables", {
        attrs: {
          "storage-key": "recruitTasks_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          serviceEndField: _vm.serviceEndField,
          fieldKey: "id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      }),
      _vm._v(" "),
      _c("recruit-task", {
        ref: "recruit_task",
        attrs: {
          "location-id": _vm.locationId,
          "location-name": _vm.locationName,
          "is-integrated": _vm.isIntegrated
        },
        on: { refresh: _vm.getItems, "modal-closed": _vm.onModalClosed }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8910a04a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8910a04a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recruiting/RecruitTasks.vue
// module id = null
// module chunks = 